import React from "react";
import useModal from "../../common/components/modals/useModal";
import { useLocalSearchView } from "../../common/useLocalSearchView";

interface ClearSearchProps {
	namespace: string;
	onClearSearch: React.MouseEventHandler<HTMLButtonElement>;
}

export function ClearSearch({ namespace, onClearSearch }: ClearSearchProps) {
	const { onCloseModal } = useModal();
	const { clearSearchView } = useLocalSearchView(namespace);

	const handleClearSearchClick = (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
	) => {
		onClearSearch(e);
		onCloseModal();
		clearSearchView();
	};

	return (
		<button
			type="button"
			className="btn btn--secondary btn--clear-search"
			onClick={handleClearSearchClick}
		>
			Clear search
		</button>
	);
}
